package com.kelimesoft.etutpro.models

data class FuncResult(
    var result: Boolean,
    val error: String? = null,
)
